import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent {

  constructor(@Inject(DOCUMENT) private document: Document, private route: ActivatedRoute, private titleService: Title) { }

  ngOnInit() {
    this.document.body.classList.add('toggle-sidebar');

    this.titleService.setTitle("Privacy Policy" + " | RankAhead");
  }
}
